import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    offset: { type: Number, default: 8 }
  }

  connect() {
    this.lastScrollY = window.scrollY
    this.ticking = false
    this.isHidden = false

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    if (this.ticking) return

    this.ticking = true
    requestAnimationFrame(() => {
      const currentY = window.scrollY
      const delta = currentY - this.lastScrollY

      if (Math.abs(delta) > this.offsetValue) {
        if (delta > 0 && currentY > 0) {
          this.hide()
        } else {
          this.show()
        }
        this.lastScrollY = currentY
      }

      this.ticking = false
    })
  }

  hide() {
    if (this.isHidden) return

    this.element.classList.add('navbar--hidden')
    this.isHidden = true
  }

  show() {
    if (!this.isHidden) return

    this.element.classList.remove('navbar--hidden')
    this.isHidden = false
  }
}


